import type { SVGProps } from "react";

export const Clickhouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="2222"
    viewBox="0 0 9 8"
    width="2500"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Clickhouse</title>
    <path d="m0 7h1v1h-1z" fill="#f00" />
    <path
      d="m0 0h1v7h-1zm2 0h1v8h-1zm2 0h1v8h-1zm2 0h1v8h-1zm2 3.25h1v1.5h-1z"
      fill="#fc0"
    />
  </svg>
);

export default Clickhouse;
